module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hres83e-calendar-year calendar-box-year calendar-bg-white"
  }, [_c('div', {
    staticClass: "calendar-text-center",
    staticStyle: {
      "font-size": "1.4em"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-left fa-lg",
    staticStyle: {
      "padding-right": "11px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.setSelectYear(-1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-year"
  }, [_c('hrms-dropdown-year', {
    attrs: {
      "minYear": 1980,
      "maxYear": 2100,
      "nowLang": "en"
    },
    model: {
      value: (_vm.selectionYear),
      callback: function($$v) {
        _vm.selectionYear = $$v
      },
      expression: "selectionYear"
    }
  })], 1), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-right fa-lg",
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.setSelectYear(1)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ae9255e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres83e/year.vue
// module id = 3792
// module chunks = 1